"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSplashScreenLayoutBlock = exports.StyledSplashScreenLayoutLangSelectorContainer = exports.StyledSplashScreenLayoutBody = exports.StyledSplashScreenLayout = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../../helpers");
const layouts_1 = require("./..");
const productTitleAndIconHeight = '94px';
const ReferenceHeightToTopPaddingRatio = '25%';
exports.StyledSplashScreenLayout = (0, styled_components_1.default)(layouts_1.AppLayout) `
    overflow: auto;
`;
exports.StyledSplashScreenLayoutBody = (0, styled_components_1.default)(layouts_1.AppLayoutBody) `
    ${({ theme }) => (0, styled_components_1.css) `
        background: transparent
            linear-gradient(
                180deg,
                ${theme === null || theme === void 0 ? void 0 : theme.colorLoginBackground1} 0%,
                ${theme === null || theme === void 0 ? void 0 : theme.colorLoginBackground2} 56%,
                ${theme === null || theme === void 0 ? void 0 : theme.colorLoginBackground3} 100%
            )
            0 0 no-repeat padding-box;
    `}

    ${({ imageSrc }) => imageSrc &&
    (0, styled_components_1.css) `
            position: relative;

            :after {
                position: absolute;
                content: ' ';
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                background-image: url('${imageSrc}');
                background-repeat: no-repeat;
                background-position: bottom right;
                background-size: auto 50%;

                @media (min-height: 900px) {
                    background-size: auto;
                }
            }
        `}
`;
exports.StyledSplashScreenLayoutLangSelectorContainer = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${helpers_1.SIZE_L} 0;
`;
exports.StyledSplashScreenLayoutBlock = styled_components_1.default.div `
    height: calc(${ReferenceHeightToTopPaddingRatio} - ${productTitleAndIconHeight});
    min-height: ${helpers_1.SIZE_M};
`;
//# sourceMappingURL=SplashScreenLayout.styles.js.map